__turbopack_context__.v({
  "clearButton": "DebouncedInput-module-scss-module__PB-HgW__clearButton",
  "flushButton": "DebouncedInput-module-scss-module__PB-HgW__flushButton",
  "root": "DebouncedInput-module-scss-module__PB-HgW__root",
  "singleView": "DebouncedInput-module-scss-module__PB-HgW__singleView",
});
